"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatConfigHeaderData = exports.getLiveStatus = exports.formatImgUrl = exports.cutStrByLen = exports.getStrLength = exports.formatshowtime = exports.getQueryParams = exports.getRankClass = exports.showface = exports.dateFormat = exports.debounce = exports.getLuyanStatus = exports.getColor = exports.toPercent = void 0;
var config = require("../../../config/web");
/**
 * 百分比
 * @param data
 * @param num
 */
function toPercent(data, num) {
    if (data === '' || data === null || isNaN(data)) {
        return '-';
    }
    num = isNaN(parseInt(num)) ? 2 : parseInt(num);
    // let fh = data >= 0 ? "+" : "";
    var fh = data > 0 ? "+" : "";
    return !isNaN(parseFloat(data)) ? fh + parseFloat(data).toFixed(num) + '%' : '-';
}
exports.toPercent = toPercent;
/**
 * 获取颜色
 * @param data 判断的字段数据
 * @param arr 得到的数据组
 */
function getColor(data, arr) {
    if (!arr || arr.length != 3) {
        arr = ['text-red', 'text-green', ''];
    }
    data = parseFloat(data);
    return !!data ? (data == 0 ? '' : data > 0 ? arr[0] : arr[1]) : arr[2];
}
exports.getColor = getColor;
/**
 * 通过路演状态获取html
 * @param type
 */
function getLuyanStatus(type, istest) {
    if (istest)
        return "";
    switch (type) {
        case 1:
            return "<span id=\"lystatustag\" class=\"tag zhibo\">\u76F4\u64AD\u4E2D</span>"; //<span id="lystatustag" class="tag zhibo">LIVE</span>  //直播不展示
        case 3:
            return "<span id=\"lystatustag\" class=\"tag huigu\">\u56DE\u987E</span>";
        case 4:
            return "<span id=\"lystatustag\" class=\"tag yugao\">\u9884\u544A</span>";
        default:
            return '';
    }
}
exports.getLuyanStatus = getLuyanStatus;
/**
 * 节流
 * @param fn
 * @param delay
 */
function debounce(fn, delay) {
    if (delay === void 0) { delay = 500; }
    var timer = null;
    return function () {
        var context = this;
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}
exports.debounce = debounce;
/**
 * 解读低版本浏览器 时间格式化bug
 * @param dateStringInRange 2019-11-05 13:23:05
 */
function parseISO8601(dateStringInRange) {
    var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*(\d{1,2}):(\d{1,2}):(\d{1,2})\s*$/, 
    // let isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
    date = new Date(NaN), month, parts = isoExp.exec(dateStringInRange);
    if (parts) {
        month = +parts[2];
        date.setFullYear(parts[1], month - 1, parts[3]);
        date.setHours(parts[4] || 0, parts[5] || 0, parts[6] || 0);
        if (month != date.getMonth() + 1) {
            date.setTime(NaN);
        }
    }
    return date;
}
/**
 * 格式化时间
 * @param date 时间
 * @param part 格式 yyyy-MM-dd HH:mm:ss
 */
function dateFormat(str, part) {
    var date = new Date(str);
    if (isNaN(date)) {
        date = parseISO8601(str);
    }
    var redate = "";
    part = (part == null) ? "yyyy-MM-dd" : part;
    var y = date.getFullYear();
    var M = date.getMonth() + 1;
    var d = date.getDate();
    var H = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    var MM = (M > 9) ? M : "0" + M;
    var dd = (d > 9) ? d : "0" + d;
    var HH = (H > 9) ? H : "0" + H;
    var mm = (m > 9) ? m : "0" + m;
    var ss = (s > 9) ? s : "0" + s;
    redate = part.replace("yyyy", y).replace("MM", MM).replace("dd", dd).replace("HH", HH).replace("mm", mm).replace("ss", ss).replace("M", M).replace("d", d).replace("H", H).replace("m", m).replace("s", s);
    return redate;
}
exports.dateFormat = dateFormat;
/*
 *@description:
 *@modifyContent:genghuan
 *@author: qiuhongyang
 *@date: 2020-07-15 13:26:29
 *
*/
function showface(html) {
    var facearr = ["微笑", "大笑", "鼓掌", "为什么", "哭", "怒", "滴汗", "俏皮", "傲", "好困惑", "兴奋", "加油", "困顿", "想一下", "撇嘴", "色", "发呆", "得意", "害羞羞", "大哭", "呲牙", "惊讶", "囧", "抓狂", "偷笑", "愉快", "憨笑", "晕", "再见", "坏笑", "左哼哼", "右哼哼", "哈欠", "委屈", "快哭了", "亲", "可怜", "口罩", "笑哭", "惊吓", "哼", "捂脸", "奸笑", "吃瓜", "旺柴", "围观", "摊手", "爱心", "献花", "福", "拜神", "胜利", "赞", "握手", "抱拳", "勾引", "拳头", "OKOK", "强壮", "毛估估", "亏大了", "赚大了", "牛", " ", "成交", "财力", "护城河", "复盘", "买入", "卖出", "满仓", "空仓", "抄底", "看多", "看空", "加仓", "减仓", "上涨", "下跌", "财神", "火箭", "龙头", "韭菜", "面", "泡沫", "惨!关灯吃面"];
    var re = new RegExp('\\[[^ \f\n\r\t\v<>]+?\\]', "ig");
    html = html.replace(re, function (item) {
        for (var i = 0; i < facearr.length; i++) {
            if ("[" + facearr[i] + "]" == item) {
                return '<img title="' + facearr[i] + '" src="//gbfek.dfcfw.com/face/emot_default_28x28/emot' + (i + 1) + '.png" alt="' + item + '" class="article_icon">';
            }
        }
        return item;
    });
    return html;
}
exports.showface = showface;
/**
 * 获取排序名次颜色
 * @param index 名次
 */
function getRankClass(index) {
    var className = '';
    switch (index) {
        case 1:
            className = 'r_red';
            break;
        case 2:
            className = 'r_orange';
            break;
        case 3:
            className = 'r_yellow';
            break;
    }
    return className;
}
exports.getRankClass = getRankClass;
/**
   * 获取url search参数
   * @param name 名称
   */
function getQueryParams(name) {
    var urlpara = location.search;
    var par = {};
    if (urlpara != "") {
        urlpara = urlpara.substring(1, urlpara.length);
        var para = urlpara.split("&");
        var parname;
        var parvalue;
        for (var i = 0; i < para.length; i++) {
            parname = para[i].substring(0, para[i].indexOf("="));
            parvalue = para[i].substring(para[i].indexOf("=") + 1, para[i].length);
            par[parname] = parvalue;
        }
    }
    if (typeof (par[name]) != "undefined") {
        return par[name];
    }
    else {
        return null;
    }
}
exports.getQueryParams = getQueryParams;
/**
 * 路演时间处理
 * ps:仅限路演特殊处理
*/
function formatshowtime(begin, end) {
    var back = "";
    try {
        //当前时间
        var curTime = new Date();
        var cy = curTime.getFullYear();
        var cm = (curTime.getMonth() + 1) < 10 ? '0' + (curTime.getMonth() + 1) : curTime.getMonth() + 1;
        var cd = curTime.getDate();
        var c_d = cd < 10 ? '0' + cd : cd; //当前日
        var c_ym = cy + '' + cm; //当前年月
        //开始时间
        var b_ymd = begin.split('T')[0];
        var b_ym = b_ymd.substr(0, 7).replace('-', "");
        var b_hs = begin.split('T')[1].substr(0, 5);
        //结束时间
        var e_ymd = end.split('T')[0];
        var e_ym = e_ymd.substr(0, 7).replace('-', "");
        var e_hs = end.split('T')[1].substr(0, 5);
        var b_d = b_ymd.split('-')[2];
        var e_d = e_ymd.split('-')[2];
        if (b_ymd == e_ymd) { //如果开始和结束是同一天,且和当前时间同年同月
            if (c_d == e_d && c_ym == e_ym) {
                e_ymd = '今天';
            }
            back = e_ymd + ' ' + b_hs + '-' + e_hs;
        }
        else {
            back = b_ymd + ' ' + b_hs + ' - ' + e_ymd + ' ' + e_hs;
        }
    }
    catch (error) {
    }
    return back;
}
exports.formatshowtime = formatshowtime;
/**
 *
 *
 * @export 获取字符串长度
 * @param {string} val
 * @returns
 */
function getStrLength(val) {
    try {
        var len = 0;
        for (var i = 0; i < val.length; i++) {
            var a = val.charAt(i);
            if (a.match(/[^\x00-\xff]/ig) != null) {
                len += 2;
            }
            else {
                len += 1;
            }
        }
        return len;
    }
    catch (error) {
        return 0;
    }
}
exports.getStrLength = getStrLength;
/**
 * 截取指定长度字符串
 * @param str
 * @param L
 * @returns
 */
function cutStrByLen(str, L) {
    var result = '', strlen = str.length, // 字符串长度
    chrlen = str.replace(/[^\x00-\xff]/g, '**').length; // 字节长度
    if (chrlen <= L) {
        return str;
    }
    for (var i = 0, j = 0; i < strlen; i++) {
        var chr = str.charAt(i);
        if (/[\x00-\xff]/.test(chr)) {
            j++;
        }
        else {
            j += 2;
        }
        if (j <= L) {
            result += chr;
        }
        else {
            return result;
        }
    }
}
exports.cutStrByLen = cutStrByLen;
/**
 * 图片大小处理
 * 按宽度等比缩放：?imageMogr2/thumbnail/宽度x
 * 按高度等比缩放：?imageMogr2/thumbnail/x高度
 *
 * ?imageMogr2/auto-orient/thumbnail/500x
 */
function formatImgUrl(url, width, height) {
    if (!url)
        return "";
    var imgstr = url.replace("http://", "https://");
    var w = width ? width : 500, h = height ? height : 400;
    if ((imgstr).indexOf("https://emav-") > -1 || (imgstr).indexOf("https://cover-") > -1) {
        imgstr += "?imageMogr2/thumbnail/".concat(w, "x");
    }
    ;
    return imgstr;
}
exports.formatImgUrl = formatImgUrl;
/**
 * 直播类型转换
 * @param status
 * @returns
 */
var getLiveStatus = function (status) {
    if (!status)
        return "";
    switch (status) {
        case 1:
            return {
                txt: "\u76F4\u64AD\u4E2D",
                type: "zb"
            };
        case 3:
            return {
                txt: "\u56DE\u987E",
                type: "hg"
            };
        case 4:
            return {
                txt: "\u9884\u544A",
                type: "yg"
            };
        default:
            return {
                txt: "",
                type: ""
            };
    }
};
exports.getLiveStatus = getLiveStatus;
/**
 * 头部菜单格式化
 * @param res
 * @returns
 */
var formatConfigHeaderData = function (res) {
    if (res === void 0) { res = []; }
    var arr = [];
    if (!res || res.length < 1) {
        return arr;
    }
    ;
    // console.log(res)
    //.filter((v:any)=> v.sub_data_set.length>0)
    arr = res.map(function (v) {
        return {
            column_name: v.column_name,
            column_id: v.column_id,
            path: "/list?type=".concat(v.column_id),
            isexact: false,
            sub_data_set: v.sub_data_set
        };
    });
    arr.unshift({
        column_name: "首页",
        column_id: "",
        path: "/",
        isexact: true,
        sub_data_set: []
    });
    return arr;
};
exports.formatConfigHeaderData = formatConfigHeaderData;
//# sourceMappingURL=data:application/json;base64,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